import React from "react";
function Check(){
return(
 <h1>Welcome to the check page</h1>
);
}
export default Check;